module.exports = __webpack_public_path__ + "static/img/accident.0a0878b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/accident.jpg
// module id = 238
// module chunks = 6